export default __webpack_public_path__ + "static/media/imperial.b3f263de.png";